export class ExerciseTypeAttribute {
	static Weight = 'weight';
	static Reps = 'reps';
	static Distance = 'distance';
	static Time = 'time';
}